module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "brutto brutto--kindergarten text-dark"
  }, [_c('button', {
    staticClass: "do-bttn",
    on: {
      "click": _vm.setIsNormModal
    }
  }, [_vm._v("Tildel årsverk")]), _vm._v(" "), (_vm.isActive) ? _c('DModal', {
    attrs: {
      "isBgOverlay": true,
      "showClose": false
    }
  }, [_c('div', {
    staticClass: "brutto-container",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "brutto-container__header"
  }, [_c('h2', [_vm._v("Tildel årsverk")]), _vm._v(" "), _c('div', {
    staticClass: "icon__bg-circle doc-modal__close",
    on: {
      "click": _vm.close
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "brutto-container__body"
  }, [_c('div', {
    staticClass: "brutto-container__body__left"
  }, [_c('h3', [_vm._v("Arbeidsåret")]), _vm._v(" "), _c('div', {
    staticClass: "d-tabs__content"
  }, [_c('ArbeidsplanAssignHoursNormList', {
    attrs: {
      "isNetto": _vm.activeTab === 1,
      "schoolYear": _vm.activeSchoolYear,
      "theEditUserNorm": _vm.theEditUserNorm
    },
    on: {
      "updated": _vm.setItemsToSave,
      "changedSum": _vm.setNettoTime
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "brutto__items__item__container brutto__items__item__container__notefield"
  }, [_c('div', {
    staticClass: "label-with-toggle",
    on: {
      "click": _vm.setIsShowAgreement
    }
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Legg til et notat til valgte personer")]), _vm._v(" "), _c('app-toggle', {
    attrs: {
      "allowChanges": false,
      "propOn": _vm.isShowAgreement
    }
  })], 1), _vm._v(" "), (_vm.isShowAgreement) ? _c('AppEIPWYZIWYG', {
    attrs: {
      "isKeepOpen": true,
      "is-open": true,
      "isInTestOfSaveButton": false
    },
    on: {
      "changed": _vm.updateAgreements
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isShowAgreement) ? _c('h4', {
    staticClass: "text-explainer"
  }, [_c('svg', {
    staticClass: "icon-archive tw-icon",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    staticClass: "primary",
    attrs: {
      "d": "M5.23 3h13.54a2 2 0 0 1 1.98 2.22l-1.55 14A2 2 0 0 1 17.2 21H6.79a2 2 0 0 1-1.99-1.78l-1.55-14A2 2 0 0 1 5.23 3z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "secondary",
    attrs: {
      "d": "M10.59 14l-2.3-2.3a1 1 0 0 1 1.42-1.4L12 12.58l2.3-2.3a1 1 0 0 1 1.4 1.42L13.42 14l2.3 2.3a1 1 0 0 1-1.42 1.4L12 15.42l-2.3 2.3a1 1 0 1 1-1.4-1.42L10.58 14zM4 3h16a2 2 0 0 1 2 2v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V5c0-1.1.9-2 2-2z"
    }
  })]), _vm._v("\n              Merk at hvis det allerede står noe i personens notatfelt, vil dette bli slettet.\n            ")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "brutto__users"
  }, [(_vm.tags.length > 0) ? _c('div', {
    staticClass: "brutto__users__header"
  }, [_c('filterTags', {
    attrs: {
      "users": _vm.usersSortedOnNameWithTags,
      "tags": _vm.tags,
      "selectedTags": _vm.appliedFilters
    },
    on: {
      "set": _vm.setTagFromFilter,
      "remove": _vm.removeTagFromFilter
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "brutto__users__list__header",
    on: {
      "click": _vm.toggleAll
    }
  }, [(_vm.selectedUsers.length < 1) ? _c('span', [_vm._v("Velg alle")]) : _c('span', [_vm._v("Fjern valg")])]), _vm._v(" "), _c('ul', {
    staticClass: "brutto__users__list"
  }, _vm._l((_vm.filteredUsers), function(user) {
    return _c('li', {
      key: user.id,
      staticClass: "brutto__users__user",
      class: {
        'is-selected': _vm.getIsUserSelected(user)
      },
      on: {
        "click": function($event) {
          return _vm.toggleUser(user)
        }
      }
    }, [_vm._v("\n              " + _vm._s(user.name) + "\n              "), _c('div', {
      staticClass: "icon__bg-circle d-edit-btn",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.editUserNorm(user)
        }
      }
    }, [_c('span', {
      staticClass: "icon-wrench"
    })])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "brutto-container__footer"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.isActive = false
      }
    }
  }, [_vm._v("Annullér")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        arrow: true,
        onShow: function () { return _vm.selectedUsers.length < 1; }
      }),
      expression: "{\n                  arrow: true,\n                  onShow: () => selectedUsers.length < 1\n                }"
    }],
    staticClass: "bttn bttn-primary",
    class: [{
      'bttn-primary--disabled': _vm.selectedUsers.length < 1
    }, {
      'bttn--loading': _vm.isSaving
    }],
    attrs: {
      "content": "Der skal vælges minimum en bruger"
    },
    on: {
      "click": function($event) {
        _vm.isWarningActive = true
      }
    }
  }, [_vm._v("Lagre\n        ")])])])]) : _vm._e(), _vm._v(" "), (_vm.isWarningActive) ? _c('DModal', {
    staticStyle: {
      "z-index": "999999999"
    },
    attrs: {
      "isBgOverlay": true,
      "showClose": false
    }
  }, [_c('div', {
    staticClass: "brutto-warning",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "brutto-warning__header"
  }, [_c('h2', [_vm._v("Gem og erstat?")]), _vm._v(" "), _c('div', {
    staticClass: "icon__bg-circle doc-modal__close",
    on: {
      "click": function($event) {
        _vm.isWarningActive = false
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "brutto-warning__body"
  }, [_c('svg', {
    staticClass: "tw-icon tw-icon--red",
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "9",
      "x2": "12",
      "y2": "13"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "17",
      "x2": "12.01",
      "y2": "17"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text-explainer"
  }, [_vm._v("\n          Du er i ferd med å tildele arbeidstid på " + _vm._s(_vm.nettoTime) + " til de valgte brukerne. Hvis det allerede er tildelt arbeidstid, vil denne bli erstattet.\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "brutto-warning__footer"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.isWarningActive = false
      }
    }
  }, [_vm._v("Annullér")]), _vm._v(" "), _c('button', {
    staticClass: "bttn bttn-primary bttn-primary--small",
    class: [{
      'bttn--loading': _vm.isSaving
    }],
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n          Lagre og erstatt\n        ")])])])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5c060ea8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Arbeidsplan/ArbeidsplanAssignHoursNorm.vue
// module id = 1620
// module chunks = 1